import api from './api';
import type { Dispute, DisputeAdminListItem, PaginatedResponse } from '../types';

export type DisputeOutcome =
  | 'upheld' | 'corrected' | 'confidence_adjusted'
  | 'data_excluded' | 'more_info' | 'dismissed';

export const disputesApi = {
  list(params?: { page?: string; status?: string }) {
    return api.get<PaginatedResponse<Dispute>>('/disputes/', { params })
      .then((r) => r.data);
  },
  create(body: {
    reason: string;
    justification: string;
    related_score_snapshot?: string;
    related_upload?: string;
    related_parsed_event?: string;
    related_rule_trigger?: string;
  }) {
    return api.post<Dispute>('/disputes/', body).then((r) => r.data);
  },
  openCount() {
    return api.get<{ count: number }>('/disputes/open-count/').then((r) => r.data);
  },

  // Admin
  adminList(params?: { page?: string; status?: string; severity?: string; reason?: string }) {
    return api.get<PaginatedResponse<DisputeAdminListItem>>(
      '/admin-panel/disputes/', { params },
    ).then((r) => r.data);
  },
  adminGet(id: string) {
    return api.get<Dispute>(`/admin-panel/disputes/${id}/`).then((r) => r.data);
  },
  adminResolve(id: string, body: { outcome: DisputeOutcome; notes?: string }) {
    return api.post(`/admin-panel/disputes/${id}/resolve/`, body);
  },
};
